/* eslint-disable @typescript-eslint/no-unused-vars */
import { inject, Injectable } from '@angular/core';
import { EnvService } from '@seahorse/common';
import { FileModel, FileService } from '@seahorse/domain';
import { Subject } from 'rxjs';
import { FileDropModel } from './file-drop.model';
import { FileListCardComponent } from './files-list-card/file-list-card.component';
import { PhotoGalleryCardComponent } from './photo-gallery-card/photo-gallery-card.component';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseFilesCardService {
  env = inject(EnvService);
  private _reloadSub = new Subject<void>();
  reload$ = this._reloadSub.asObservable();
  protected filesData = inject(FileService);

  reload() {
    this._reloadSub.next();
  }

  setMatchingLinkedObjects(files: FileModel[], linkedObjectsIds: any[]) {
    if (!this.env.useFileUploadWizard || !linkedObjectsIds) {
      return [];
    }

    const matchingLinkedObjects: any[] = [];

    files.forEach((file) => {
      if (file.objectFiles && Array.isArray(file.objectFiles)) {
        file.objectFiles.forEach((objectFile) => {
          Object.keys(linkedObjectsIds).forEach((key) => {
            const linkedObjectValue = linkedObjectsIds[key];

            let isMatch = false;
            if (Array.isArray(linkedObjectValue)) {
              isMatch = linkedObjectValue.includes(objectFile.objectId);
            } else if (typeof linkedObjectValue === 'string') {
              isMatch = linkedObjectValue === objectFile.objectId;
            }

            if (isMatch) {
              file.hasLinkedObjects = true;
              const existingObject = matchingLinkedObjects.find(
                (item) => item.key === key && item.fileId === file.id
              );
              if (existingObject) {
                existingObject.ids.push(objectFile.objectId);
              } else {
                matchingLinkedObjects.push({
                  key: key,
                  ids: [objectFile.objectId],
                  fileId: file.id,
                });
              }
            }
          });
        });
      }
    });

    return matchingLinkedObjects;
  }

  filesAdd(
    component: FileListCardComponent | PhotoGalleryCardComponent,
    fileDropped?: FileDropModel,
    source?: string
  ) {
    throw new Error('Not implemented');
  }

  openImportLinkedObjectsModal(
    file: FileModel,
    component: FileListCardComponent | PhotoGalleryCardComponent
  ) {
    throw new Error('Not implemented');
  }

  getFileById(file: FileModel) {
    return this.filesData.getFileById(file.id);
  }
}
